/**
 * The main site's /oauth/google-login: Google comes back here, the API checks
 * the answer, and the browser goes on to the site that started the sign-in
 * (the main site or an agency's portal) with a one-time grant.
 */

import { useEffect, useState, type ReactNode } from 'react';

import { finishGoogleSignIn } from './google-signin.ts';

export const GOOGLE_CALLBACK_PATH = '/oauth/google-login';

export function GoogleCallback(): ReactNode {
  const [problem, setProblem] = useState<string | null>(null);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    if (params.get('error') || !code || !state) {
      setProblem('Google sign-in was cancelled.');
      return;
    }
    finishGoogleSignIn(code, state)
      .then((redirect) => window.location.replace(redirect))
      .catch((error: unknown) =>
        setProblem(error instanceof Error ? error.message : 'Google sign-in failed.'),
      );
  }, []);
  return (
    <main className="li-callback" aria-live="polite">
      {problem ? (
        <p>
          {problem} <a href="/">Back to sign in</a>
        </p>
      ) : (
        <p>Signing you in…</p>
      )}
    </main>
  );
}
